import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalFormPropriedadePageRoutingModule } from './modal-form-propriedade-routing.module';

import { ModalFormPropriedadePage } from './modal-form-propriedade.page';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MatFormFieldModule,
    MatInputModule,
    ModalFormPropriedadePageRoutingModule
  ],
  declarations: [ModalFormPropriedadePage]
})
export class ModalFormPropriedadePageModule {}
